/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebComponents {
    "use strict";

    import ILocation = DealerwareWebServices.ILocation;

    export interface ILocationDetailFormDirectiveControllerScope extends ng.IScope {
        locationDetailForm: ng.IFormController;
    }

    export class LocationDetailFormDirectiveController {

        public static $inject : string[] = [
            'DataUtils',
            '$scope',
            '$mobilityCompanyAuthentication',
            '$dealerwareLoading',
            '$dealerwareNotification',
            '$mdDialog'
        ];

        public location     : ILocation;
        private dataUtils   : any;

        constructor(public DataUtils: any,
                    public $scope: ILocationDetailFormDirectiveControllerScope,
                    public $mobilityCompanyAuthentication: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public $mdDialog: any) {
            this.dataUtils = DataUtils.getInstance();
            this.$scope = $scope;
        }

        public save() : void {
            var _self = this;

            var loader = this.$dealerwareLoading.show('Saving...');
            this.location.saveSettings().then((location: ILocation) => {
                _self.location = location;
                _self.location.settings.custom_minimum_age = _self.location.settings.minimum_age !== 21;
                this.updateCachedLocationSettings();
                loader.close();
                _self.$dealerwareNotification.toast('Location saved');
            }).catch((response: any) => {
                _self.$dealerwareNotification.apiError(response);
                loader.close();
            });
        }

        public isSaveDisabled () : boolean {
            if (this.$scope.locationDetailForm && this.location) {
                return (this.$scope.locationDetailForm.$invalid
                        || this.$scope.locationDetailForm.$pristine
                        || this.location.areSettingsUnchanged());
            }

            return true;
        }

        public updateCachedLocationSettings() : void {
            var cachedLocation = this.$mobilityCompanyAuthentication.location;

            if (cachedLocation.id === this.location.id) {
                cachedLocation.settings = this.location.settings;
                this.$mobilityCompanyAuthentication.setLocation(cachedLocation);
            }
        }

        public checkForAllowViewVehicleLocation () {

            var defaults = (<any>this.location)._defaults;

            // Don't do the confirmation modal if switching to off, or if the last
            // saved state of the switch was on.
            //
            if ( ! this.location.settings.view_vehicle_under_contract
                 || defaults.settings.view_vehicle_under_contract
               ) {
                return;
            }

            var confirmationText = 'As a representative of <b>' + this.location.primary_name + '</b>, '
                + 'I agree to adhere to all federal and/or local laws regarding the visibility '
                + 'of vehicle locations while they are under contract.';

            var confirm = this.$mdDialog.confirm()
                .htmlContent(confirmationText)
                .ariaLabel(confirmationText)
                .ok('Agree')
                .cancel('Cancel');

            this.$mdDialog.show(confirm)
                .then( angular.noop, ( ) => {
                    this.location.settings.view_vehicle_under_contract = false
                });
        }
    }

    getDealerwareWebComponentsModule().controller('LocationDetailFormDirectiveController', LocationDetailFormDirectiveController);


    export class LocationDetailFormDirective implements ng.IDirective {

        public restrict         : string    =   'EA';
        public controller       : any       =   'LocationDetailFormDirectiveController';
        public controllerAs     : string    =   'locationDetailController';
        public bindToController : boolean   =   true;
        public scope            : Object    =   { location: '=' };
        public templateUrl      : string    =   '/components/location/location-detail-form-directive.html';
    }

    getDealerwareWebComponentsModule().directive("dealerwareLocationDetailForm",() => new LocationDetailFormDirective());
}
